exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".models-slider-website-component[data-brand=infiniti] .sokal-btn[data-v-0b0f4e16]{border:3px solid var(--primary-color,#020b24);-webkit-transition-property:all;transition-property:all;border-radius:50px}.models-slider-website-component[data-brand=infiniti] .sokal-btn[data-v-0b0f4e16]:after{display:none}.models-slider-website-component[data-brand=infiniti] .sokal-btn[data-v-0b0f4e16]:focus,.models-slider-website-component[data-brand=infiniti] .sokal-btn[data-v-0b0f4e16]:hover{background-color:var(--primary-light,#fff)}", ""]);

// exports
